import { render, staticRenderFns } from "./Auto.vue?vue&type=template&id=04935cc2&scoped=true&"
import script from "./Auto.vue?vue&type=script&lang=js&"
export * from "./Auto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04935cc2",
  null
  
)

export default component.exports